import { ISbStoryData } from 'storyblok-js-client';

import { getStories } from '@monoimin/storyblok/getStories';

export async function getFlatStories<T>(
  params: { [k: string]: string | number | object },
  flatStories: ISbStoryData<T>[] = [],
  page = 1
) {
  const {
    total,
    data: { stories },
  } = await getStories<T>({
    version: 'published',
    per_page: 100,
    page,
    ...params,
  });

  flatStories.push(...stories);
  if (flatStories.length < total) {
    await getFlatStories(params, flatStories, page + 1);
  }

  return flatStories as ISbStoryData<T>[];
}

export default getFlatStories;
